// extracted by mini-css-extract-plugin
module.exports = {"title":"_36OAjUciAH-l68b0cSUE1X","desc-title":"c5D_3xHvh99SX78IaF8TS","btn-login":"_3UjJJDp7qrcRW82gzLD2CF"};